import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { App } from './App';
import { currentLanguage, i18n } from './shared/i18n';
import { applyTheme, readThemeChoice } from './shared/ui/theme';
import './styles/index.css';

/*
  Тема ставится до первой отрисовки, а не в оболочке: выбравший светлую
  иначе получал бы при каждой загрузке вспышку тёмного фона — страница
  успевает нарисоваться раньше, чем React доберётся до шапки.
*/
applyTheme(readThemeChoice());

/*
  Язык документа ставится до первой отрисовки по той же причине, что и тема:
  на него смотрят и браузер (перенос слов, проверка орфографии в полях),
  и скринридер, выбирающий по нему голос. `changeLanguage` держит атрибут
  в согласии с интерфейсом дальше.
*/
document.documentElement.lang = currentLanguage();

const container = document.getElementById('root');
if (!container) {
  throw new Error('root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);
